import { BuyerNote, DeliveryInstructions, DeliverySafePlace, IossNumber } from '../../lib/consts/ItemMetaConstants';

export const MappableSmartSendCsvFields = [
  'Item Name',
  'Value',
  'Country',
  'County',
  'Email',
  'Locality',
  'Customer',
  'Postcode',
  'Property',
  'Telephone',
  'Street',
  'Town',
  'Height',
  'Reference',
  'Length',
  'Width',
  'Weight',
  'Quantity',
  'Organisation',
  'TransactionProcessed',
  'BuyerId',
  'TariffCode',
  'Eori',
  'OriginCountry',
  'ExportReason',
  'VatNumber',
  IossNumber,
  'Sku',
  'Tags',
  'Sms',
  'Print in Store',
  'Sender VAT Number',
  'Sender EORI Number',
  'Cover',
  'Signature',
  'Delivery Guarantee',
  'First Name',
  'Last Name',
  'Service',
  DeliveryInstructions,
  DeliverySafePlace,
  BuyerNote,
  'LabelReference'
];
